// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see LimitsBrowseScreenEvent
 */
export var LimitsBrowseScreen = function (_a) {
    var screenType = _a.screenType, flowToken = _a.flowToken;
    return ({
        name: "Limits Browse Screen",
        parameters: {
            cdf_entity: "Limits",
            cdf_action: "Browse",
            screen_type: screenType !== undefined && screenType !== null ? screenType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see LimitsBrowseLimitTypeScreenEvent
 */
export var LimitsBrowseLimitTypeScreen = function (_a) {
    var limitType = _a.limitType, flowToken = _a.flowToken;
    return ({
        name: "Limits Browse LimitTypeScreen",
        parameters: {
            cdf_entity: "Limits",
            cdf_action: "Browse",
            limit_type: limitType !== undefined && limitType !== null ? limitType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see LimitsInteractTapLimitTypeRowEvent
 */
export var LimitsInteractTapLimitTypeRow = function (_a) {
    var limitType = _a.limitType, flowToken = _a.flowToken;
    return ({
        name: "Limits Interact TapLimitTypeRow",
        parameters: {
            cdf_entity: "Limits",
            cdf_action: "Interact",
            limit_type: limitType !== undefined && limitType !== null ? limitType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
